export const ADMIN_PATH = '/'

export const buildK8ReportSitePath = (unitSection, siteId) =>
  `/reports/k8/${unitSection}?site=${siteId}`

export const buildDwbReportSitePath = siteId => `/reports/dwb?site=${siteId}`

export const SCHOOL_SUMMARY_BREADCRUMB = 'School Overview'
export const LESSON_COMPLETION_REPORTS_TITLE = 'Lesson Completion Reports'
